import createFixtureGenerator from './createFixtureGenerator'
import awaitedPaymentFixture from './data/awaitedPayment.fixture'
import caseContextFixture from './data/caseContext.fixture'
import caseDetailsFlagFixture from './data/caseDetailsFlag.fixture'
import caseVersionFixture from './data/caseVersion.fixture'
import clientAddressFixture from './data/clientAddress.fixture'
import clientContextFixture from './data/clientContext.fixture'
import clientHealthInfoFixture from './data/clientHealthInfo.fixture'
import clientVersionFixture from './data/clientVersion.fixture'
import commissionStructureFixture from './data/commissionStructure.fixture'
import dependantFixture from './data/dependant.fixture'
import depositFixture from './data/deposit.fixture'
import dipFixture from './data/dip.fixture'
import documentFixture from './data/document.fixture'
import documentRequirementFixture from './data/documentRequirement.fixture'
import documentVerificationFixture from './data/documentVerification.fixture'
import documentVerificationCpFixture from './data/documentVerificationCp.fixture'
import generalInsuranceProductFixture from './data/generalInsuranceProduct.fixture'
import generalInsuranceQuoteFixture from './data/generalInsuranceQuote.fixture'
import groupFixture from './data/group.fixture'
import introducerCommissionFixture from './data/introducerCommission.fixture'
import kbaAttemptFixture from './data/kbaAttempt.fixture'
import kbaChoiceFixture from './data/kbaChoice.fixture'
import kbaQuestionFixture from './data/kbaQuestion.fixture'
import kbaSubmissionResponseFixture from './data/kbaSubmissionResponse.fixture'
import lenderPanelFixture from './data/lenderPanel.fixture'
import lutherAddressFixture from './data/lutherAddress.fixture'
import miCaseFixture from './data/miCase.fixture'
import miDocumentFixture from './data/miDocument.fixture'
import miDocumentSummaryResponseFixture from './data/miDocumentSummaryResponse.fixture'
import miOrganisationFixture from './data/miOrganisation.fixture'
import mortgageFixture from './data/mortgage.fixture'
import mortgageCalculatedValuesFixture from './data/mortgageCalculatedValues.fixture'
import mortgageProductFixture from './data/mortgageProduct.fixture'
import newFeeFixture from './data/newFee.fixture'
import noteFixture from './data/note.fixture'
import organisationFixture from './data/organisation.fixture'
import productCommissionFixture from './data/productCommission.fixture'
import privateMedicalInsuranceFixture from './data/privateMedicalInsurance.fixture'
import propertyVersionFixture from './data/propertyVersion.fixture'
import protectionProductFixture from './data/protectionProduct.fixture'
import providerStatementFixture from './data/providerStatement.fixture'
import resolvedPermissionResolutionFixture from './data/resolvedPermissionResolution.fixture'
import templateFixture from './data/template.fixture'
import userFixture from './data/user.fixture'
import verificationFixture from './data/verification.fixture'
import verificationCollectionFixture from './data/verificationCollection.fixture'
import getMiCaseListFixture from './queries/getMiCaseList.fixture'
import getProviderStatementsFixture from './queries/getProviderStatements.fixture'

// Data

export const awaitedPayment = createFixtureGenerator({
  defaults: awaitedPaymentFixture,
})

export const caseContext = createFixtureGenerator({
  defaults: caseContextFixture,
})

export const caseDetailsFlag = createFixtureGenerator({
  defaults: caseDetailsFlagFixture,
})

export const caseVersion = createFixtureGenerator({
  defaults: caseVersionFixture,
})

export const clientAddress = createFixtureGenerator({
  defaults: clientAddressFixture,
})

export const clientHealthInfo = createFixtureGenerator({
  defaults: clientHealthInfoFixture,
})

export const clientVersion = createFixtureGenerator({
  defaults: clientVersionFixture,
})

export const clientUser = createFixtureGenerator({
  defaults: clientVersionFixture,
})

export const clientContext = createFixtureGenerator({
  defaults: clientContextFixture,
})

export const commissionStructure = createFixtureGenerator({
  defaults: commissionStructureFixture,
})

export const deposit = createFixtureGenerator({
  defaults: depositFixture,
})

export const document = createFixtureGenerator({
  defaults: documentFixture,
})

export const miDocumentSummaryResponse = createFixtureGenerator({
  defaults: miDocumentSummaryResponseFixture,
})

export const miDocument = createFixtureGenerator({
  defaults: miDocumentFixture,
})

export const miOrganisation = createFixtureGenerator({
  defaults: miOrganisationFixture,
})

export const dependant = createFixtureGenerator({
  defaults: dependantFixture,
})

export const dip = createFixtureGenerator({
  defaults: dipFixture,
})

export const documentVerification = createFixtureGenerator({
  defaults: documentVerificationFixture,
})

export const documentVerificationCp = createFixtureGenerator({
  defaults: documentVerificationCpFixture,
})

export const documentRequirement = createFixtureGenerator({
  defaults: documentRequirementFixture,
})

export const generalInsuranceProduct = createFixtureGenerator({
  defaults: generalInsuranceProductFixture,
})

export const generalInsuranceQuote = createFixtureGenerator({
  defaults: generalInsuranceQuoteFixture,
})

export const group = createFixtureGenerator({
  defaults: groupFixture,
})

export const introducerCommission = createFixtureGenerator({
  defaults: introducerCommissionFixture,
})

export const kbaAttempt = createFixtureGenerator({
  defaults: kbaAttemptFixture,
})

export const kbaQuestion = createFixtureGenerator({
  defaults: kbaQuestionFixture,
})

export const kbaChoice = createFixtureGenerator({
  defaults: kbaChoiceFixture,
})

export const lenderPanel = createFixtureGenerator({
  defaults: lenderPanelFixture,
})

export const lutherAddress = createFixtureGenerator({
  defaults: lutherAddressFixture,
})

export const miCase = createFixtureGenerator({
  defaults: miCaseFixture,
})

export const mortgage = createFixtureGenerator({
  defaults: mortgageFixture,
})

export const mortgageCalculatedValues = createFixtureGenerator({
  defaults: mortgageCalculatedValuesFixture,
})

export const mortgageProduct = createFixtureGenerator({
  defaults: mortgageProductFixture,
})

export const newFee = createFixtureGenerator({
  defaults: newFeeFixture,
})

export const note = createFixtureGenerator({
  defaults: noteFixture,
})

export const organisation = createFixtureGenerator({
  defaults: organisationFixture,
})

export const privateMedicalInsurance = createFixtureGenerator({
  defaults: privateMedicalInsuranceFixture,
})

export const productCommission = createFixtureGenerator({
  defaults: productCommissionFixture,
})

export const propertyVersion = createFixtureGenerator({
  defaults: propertyVersionFixture,
})

export const providerStatement = createFixtureGenerator({
  defaults: providerStatementFixture,
})

export const protectionProduct = createFixtureGenerator({
  defaults: protectionProductFixture,
})

export const resolvedPermissionResolution = createFixtureGenerator({
  defaults: resolvedPermissionResolutionFixture,
})

export const verification = createFixtureGenerator({
  defaults: verificationFixture,
})

export const verificationCollection = createFixtureGenerator({
  defaults: verificationCollectionFixture,
})

export const user = createFixtureGenerator({
  defaults: userFixture,
})

export const template = createFixtureGenerator({
  defaults: templateFixture,
})

// Queries

export const getMiCaseList = createFixtureGenerator({
  defaults: getMiCaseListFixture,
})

export const getProviderStatements = createFixtureGenerator({
  defaults: getProviderStatementsFixture,
})

// Mutations

export const kbaSubmissionResponse = createFixtureGenerator({
  defaults: kbaSubmissionResponseFixture,
})
